import { CarouselFeature } from "./feature-base.js";
const attributeName = "auto-slide-size";
const propertyName = "autoSlideSize";
class AutoSlideSizeFeature extends CarouselFeature {
  constructor(host) {
    super(host);
    host.gatherProperties([propertyName], host);
    Object.defineProperty(host, propertyName, {
      get() {
        return host.hasAttribute(attributeName);
      },
      set(val) {
        host.toggleAttribute(attributeName, !!val);
      }
    });
  }
}
export {
  AutoSlideSizeFeature
};
